import { salesService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, saless: [], sales: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        salesService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        salesService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sales');
                    dispatch('alert/success', "Sales Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sales');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        salesService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sales');
                    dispatch('alert/success', "Sales Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sales');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      salesService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/sales');
                  dispatch('alert/success', "Sales Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/sales');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_sales_by_account({ dispatch, commit }, data) {
        commit('request');

        salesService.get_sales_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        salesService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  saless: state => {
    return state.saless
  },
  sales: state => {
    return state.sales
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.sales = {};
        state.saless = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.sales = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.saless = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const sales = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
